import { render, staticRenderFns } from "./CheckoutSummaryPrice.vue?vue&type=template&id=4dfa8c6d&"
import script from "./CheckoutSummaryPrice.vue?vue&type=script&lang=js&"
export * from "./CheckoutSummaryPrice.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutSummaryPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports